import { pageHead } from "@app/lib/page-title";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense, lazy } from "react";

// The onboarding design lab, at /design/onboarding.
//
// Development only, and literally so: `import.meta.env.DEV` is replaced with
// `false` when Vite builds, which makes the conditional below a constant and
// lets the bundler drop the dynamic import with it. The lab and its fixtures
// never reach a production bundle, so there is nothing to reach.
const Lab = import.meta.env.DEV
  ? lazy(() => import("@app/pages/onboarding/lab"))
  : null;

export const Route = createFileRoute("/design/onboarding")({
  head: () => pageHead("Onboarding design lab"),
  component: DesignOnboardingRoute,
});

function DesignOnboardingRoute() {
  if (!Lab) {
    return (
      <p className="p-10 text-body">
        The design lab only runs in development.
      </p>
    );
  }

  return (
    <Suspense fallback={null}>
      <Lab />
    </Suspense>
  );
}
